/** Canonical fountain frame data shared by validation and the game adapter.
 * Adopted from the reviewed Tidewend cascade revision02; no gameplay collision. */
export const TIDAL_CASCADE_PROP_TEMPLATES = {
  tidal_cascade_fountain: { kind: 'village_well', name: 'Tidewend cascade fountain', frame: { w: 192, h: 160 }, band: 'vegetation' },
  tidal_cascade_fountain_mossgrown: { kind: 'village_well', name: 'Mossgrown cascade fountain', frame: { w: 192, h: 160 }, band: 'vegetation' },
  tidal_cascade_fountain_dry_ruin: { kind: 'village_well', name: 'Dry ruined cascade fountain', frame: { w: 192, h: 160 }, band: 'vegetation' },
} as const;
export type TidalCascadePropTemplate = keyof typeof TIDAL_CASCADE_PROP_TEMPLATES;
